/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";

import Swal from "sweetalert2";
import { putRequest } from "utils/request";

import { postRequest } from "utils/request";

import { i18n } from '../../../../translate/i18n';
import { useModal } from "hooks/modal";

export default function NewTicketType({
  handleNewTicketType,
  selectedTicketType,
  handleGoBack,
  companyData
}) {
  const [description, setDescription] = useState("");
  const [defaultTicketType, setDefaultTicketType] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const { toggleHelperId } = useModal();

  useEffect(() => {
    setLoading(true);

    setDescription(selectedTicketType.description);
    setDefaultTicketType((selectedTicketType.default) ? selectedTicketType.default : false);
    setDisabled((selectedTicketType.default) ? selectedTicketType.default : false);

    setLoading(false);
  }, []);

  useEffect(() => {
    toggleHelperId(43);
  }, [])

  const handleSendTicketType = () => {
    setLoading(true);
    

    if (selectedTicketType.id) {

      if (defaultTicketType) {
        Swal.fire({
          title: i18n.t('attemption'),
          text: i18n.t('defaultTicket'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: i18n.t('confirmEraseCompany'),
        }).then((result) => {
          if (!result.isConfirmed){
            setLoading(false);
            return;
          } else {
              putRequest(`/companiesticketstypes/${selectedTicketType.id}`, {
                CompanyId: companyData.id,
                description: description,
                default: defaultTicketType,
              })
              .then(function (response) {
                setLoading(false);
                if(response.success) {
                  handleNewTicketType();
                }
              }
            )
          }
        })
      } else {
          putRequest(`/companiesticketstypes/${selectedTicketType.id}`, {
            CompanyId: companyData.id,
            description: description,
            default: defaultTicketType,
          })
          .then(function (response) {
            setLoading(false);
            if(response.success) {
              handleNewTicketType();
            }
          }
        )      
      }
    } else {

      if (defaultTicketType) {
        Swal.fire({
          title: i18n.t('attemption'),
          text: i18n.t('defaultTicket'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: i18n.t('confirmEraseCompany'),
        }).then((result) => {
          if (!result.isConfirmed){
            setLoading(false);
            return;
          } else {
              postRequest(`/companiesticketstypes`, {
                CompanyId: companyData.id,
                description: description,
                default: defaultTicketType,
              })
              .then(function (response) {
                  setLoading(false);
                  if(response.success) {
                    handleNewTicketType();
                  }
                }
              )
            }
        });
      } else {
          postRequest(`/companiesticketstypes`, {
            CompanyId: companyData.id,
            description: description,
            default: defaultTicketType,
          })
          .then(function (response) {
            setLoading(false);
            if(response.success) {
              handleNewTicketType();
            }
          }
        )
      }        
    }
  };

  return (
    <>
      <div className="title-helper-container" style={{marginBottom: 10}}>
        <h3>{companyData.nickName}</h3>
      </div>
      {!loading ? (
        <form
          className="form-edit"
          style={{height: '60vh', overflow: 'hidden'}}
          onSubmit={(e) => {
            e.preventDefault();
            handleSendTicketType();
          }}
        >
          <div style={{paddingLeft: 0}} className="col-lg">
            <div className="form-row mt-2">
              <div className="form-group col-md-6">
                <label> {i18n.t('description')} *</label>
                <input
                  type="text"
                  className="form-control"
                  maxLength={100}
                  value={description}
                  required
                  onChange={(value) => setDescription(value.target.value)}
                /> 
              </div>
            </div>
            <div className="form-row mt-2">
            <div className="form-group col-md-6">
              <input
                type="checkbox"
                checked={defaultTicketType}
                disabled={disabled}
                onChange={(value) => {
                  setDefaultTicketType(value.target.checked);
                }}                      
              /> {i18n.t('defaultType')}
              </div> 
            </div>
            <div
              className="button-list mt-3 pull-right"
              style={{ position: "absolute", bottom: 0, right: 0 }}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handleGoBack()}
              >
                <i i className="mdi mdi-backup-restore"></i>
                {i18n.t('getBack')}
              </button>
              <button type="submit" className="btn btn-outline-success">
                <i className="mdi mdi-checkbox-marked-circle"></i>{i18n.t('save')}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </>
  );
}
